








































import Vue from 'vue'
import { mapState } from 'vuex'
import style from './style.module.scss'

import textInput from '@/components/controls/text-input/text-input.vue'
import radio from '@/components/controls/radio/radio.vue'
import selectSimple from '@/components/controls/select/select-simple.vue'

import { Project, SupplierOrganization, ProjectItem, FieldErrorModel, FormModeType  } from '@/types/supplier-search'

interface ListModel {
        id: number;
        value: string;
    }

export default Vue.extend({
    name: 'binding-to-project',
    components: {
        selectSimple,
        textInput,
        radio
    },
    props: {
        positionNameError: Object as () => FieldErrorModel
    },
    data() {
        return {
            style: style,
        }
    },
    methods: {
        updateBinding(isNewProject: boolean) {
            if(isNewProject) {
                this.$store.dispatch('deleteAllCharacteristic');
                this.$store.dispatch('copyCharacteristicsToPosition');

                this.$store.dispatch('setDefaultProject');
                this.$store.dispatch('setDefaultPosition');
            } 

            this.$store.commit('setIsNewPosition', isNewProject);
            this.$store.commit('setIsNewProject', isNewProject);

        },
        onChangePositionName() {
            this.$root.$emit('getCodesSuggestion', this.currentPosition.Name);
            if (this.currentPosition.Name.length < 1) return;
            if (this.currentProject.Name?.length < 1 || this.currentPosition.Name !== this.currentProject.Name)
                this.currentProject.Name = this.currentPosition.Name;
        },
        selectProject(projectId: string) {
            if(projectId === "-1") {
                this.$store.commit('setDefaultProject');
            }
            const id = parseInt(projectId);

            if(!isNaN(id)) {
                const project = this.projects.find((item: Project) => item.Id == id);

                this.$store.dispatch('updateCurrentProject', project);
            }
        },
    },
    computed: {
        ...(mapState<RootStateSupplierSearch>({
            supplierOrganization(state: RootStateSupplierSearch): SupplierOrganization | undefined {
                return state.supplierOrganization;
            },
            currentProject(state: RootStateSupplierSearch): Project {
                return state.currentProject;
            },
            currentPosition(state: RootStateSupplierSearch): ProjectItem {
                return state.currentPosition;
            },
            isNewProject(state: RootStateSupplierSearch): boolean {
                return state.isNewProject;
            },
            isNewPosition(state: RootStateSupplierSearch): boolean {
                return state.isNewPosition;
            },
            modeType(state: RootStateSupplierSearch): FormModeType {
                return state.modeType;
            }
        }) as MapStateToComputed<RootStateSupplierSearch>),
        hasAnyProject(): boolean {
            return this.$store.getters.hasAnyProjects;
        },
        projects(): Project[] {
            return this.$store.getters.projectsForSelect;
        },
        projectsForSelect(): ListModel[] {
            const list = this.$store.getters.projectsForSelect.map((item: Project) => {
                return {
                    id: item.Id,
                    value: item.Name
                }
            });

            return list;
        },
        isAuthentificated(): boolean {
            return this.$store.getters.isAuthentificated;
        },
        notOriginMode(): boolean {
            return this.modeType != FormModeType.Origin
        }
    }
})
